import { Component } from '@angular/core';
import { PageTitleService } from '../../../../Utils/_services/page-title/page-title.service';
import { BugReportingService } from '../../../../Utils/_services/bug-report/bug-reporting.service';
import { JobService } from '../../../../Utils/_services/job/job.service';
import { AccountService } from '../../../../Utils/_services/account/account.service';
import { ICustomError } from '../../../../Utils/_models/network-response';


@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {

  data = {
    jobs: 0,
    users: 0,
    blogs: 0,
    bugs: 0
  };

  constructor(private pageTitle: PageTitleService,
    private bugapi: BugReportingService,
    private jobapi: JobService,
    private accountService: AccountService
  ) {
  }

  ngOnInit(): void {
    this.pageTitle.setTitle('Dashboard');
    this.loadBugCount();
    this.loadJobCount();
    this.loadUserCount();
    this.loadNewsletterCount();
  }

  loadBugCount() {
    this.bugapi.getAllBugs(1, 1).subscribe({
      next: (result) => {
        this.data.bugs = result.data.totalCount; // Set totalCount to bugs
      },
      error: (err: ICustomError) => {
        console.error('Failed to load bug count:', err.error.msg);
      }
    });
  }

  loadJobCount() {
    this.jobapi.getJobs(1, 10).subscribe({
      next: (result) => {
        if (result.data.items) {
          this.data.jobs = result.data.totalCount || result.data.items.length;
          //console.log('Job count loaded:', this.data.jobs);
        } else if (Array.isArray(result)) {
          this.data.jobs = result.length;
        } else {
          this.data.jobs = 0;
        }
      },
      error: (err: ICustomError) => {
        console.error('Failed to load job count:', err.error.msg);
        this.data.jobs = 0;
      }
    });
  }

  loadUserCount() {
    this.accountService.GetAllUser(1, 1).subscribe({
      next: (result) => {
        this.data.users = result.data.totalCount || 0;
        console.log('User count loaded:', this.data.users);
      },
      error: (err: ICustomError) => {
        console.error('Failed to load user count:', err.error.msg);
        this.data.users = 0;
      }
    });
  }

  loadNewsletterCount() {
    this.accountService.GetAllUser(1, 1000).subscribe({
      next: (result) => {
        const newsletterSubscribers = (result.data.items || []).filter((user: any) => user.newsletter === true);
        this.data.blogs = newsletterSubscribers.length;
        console.log('Newsletter subscriber count loaded:', this.data.blogs);
      },
      error: (err: ICustomError) => {
        console.error('Failed to load newsletter count:', err.error.msg);
        this.data.blogs = 0;
      }
    });
  }

}
